// extracted by mini-css-extract-plugin
export var button = "button-module--button--5ffa9";
export var dark = "button-module--dark--2ba75";
export var icon = "button-module--icon--1aca3";
export var left = "button-module--left--fe5b0";
export var primary = "button-module--primary--9466e";
export var right = "button-module--right--a4c3b";
export var secondary = "button-module--secondary--26ab5";
export var tertiary = "button-module--tertiary--788a9";